import { ref } from "vue"
import { UUID } from "@avvoka/shared"
import type { V } from '@component-utils/types';

export const getUUID = () => {
  /**
   * Lazy fix for crypto#randomUUID not available for localhost when aliased
   */
  if (import.meta.env.PROD) {
    return window.crypto.randomUUID()
  } else {
    return UUID.new()
  }
}

export function useElementId (id: string | undefined) {
  return ref(id || `el-${getUUID()}`)
}

export function useDescriptionElementId (description: string | undefined, id: string) {
  return description ? `description-${id}` : undefined
}

export function getItemValue (item: V.ContextMenu.Checkbox) {
  if (typeof item.value === 'boolean') return item.value
  else return item.value.get()
}